import { render, staticRenderFns } from "./CarregandoTipoRede.vue?vue&type=template&id=0b1a83b4&scoped=true"
import script from "./CarregandoTipoRede.vue?vue&type=script&lang=js"
export * from "./CarregandoTipoRede.vue?vue&type=script&lang=js"
import style0 from "./CarregandoTipoRede.vue?vue&type=style&index=0&id=0b1a83b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1a83b4",
  null
  
)

export default component.exports